import { IUser, UserRoleEnum } from 'app/services/user';
import { ACCESS } from './accessMatrix';
import { IResourceNode } from './types';
import { AccessRule, ObjectRule } from './rules';

/** runtime helper + compile-time type-guard */
function isObjectRule(rule: AccessRule): rule is ObjectRule {
  return typeof rule === 'object' && !Array.isArray(rule);
}

function ruleAllows(user: IUser, key: keyof typeof ACCESS): boolean {
  const rule = ACCESS[key];

  if (rule === 'ALL') return true;

  // 2. role list
  if (Array.isArray(rule)) {
    return rule.some((r) => user.roles?.some((ur) => ur.name === r));
  }

  // 3. object rule
  if (isObjectRule(rule)) {
    const roleOK =
      !rule.role ||
      rule.role.some((r) => user.roles?.some((ur) => ur.name === r));

    const deptOK =
      !rule.dept ||
      rule.dept.some((d) =>
        user.accountant_profile?.departments?.some((ad) => ad.id === d),
      );

    return roleOK && deptOK;
  }

  return false;
}

/** Clone the tree keeping only items the user may see */
export function filterMenu(
  tree: IResourceNode[],
  user?: IUser,
): IResourceNode[] {
  if (!user) return [];

  return tree
    .map((n) => {
      const kids = n.children ? filterMenu(n.children, user) : undefined;
      const visible =
        ruleAllows(user, n.key as keyof typeof ACCESS) ||
        (kids && kids.length > 0);
      return visible ? { ...n, children: kids } : null;
    })
    .filter(Boolean) as IResourceNode[];
}
